import { render, staticRenderFns } from "./collapseitem.vue?vue&type=template&id=db6f3b10&"
import script from "./collapseitem.vue?vue&type=script&lang=js&"
export * from "./collapseitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports